import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { usePopupState, bindTrigger, bindMenu } from "material-ui-popup-state/hooks";
import SelectWarehouseModal from "../../../views/capture/RackLocations/StorageLocationAutocomplete/SelectWarehouseModal";
import SelectNewLocationWithin from "./SelectNewLocationWithin";

const styles = {
  selectButton: {
    mr: "1px",
    height: 36,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    minWidth: 200,
  },
  dropdownButton: {
    px: 0,
    height: 36,
    minWidth: 40,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  arrowIcon: open => ({
    transform: open ? undefined : "rotate(180deg)",
  }),
};

export default function MoveActions({
  hasMobileLocation,
  onOpenInventoryModal,
  onConsolidateMobileLocation,
  onMoveToOtherWarehouse,
  onMoveOnlyThisItem,
}) {
  const [selectWarehouseModalOpen, setSelectWarehouseModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const popupState = usePopupState({ variant: "popover", popupId: "receiver-move-locations-menu" });

  const handleConsolidateClick = () => {
    onConsolidateMobileLocation();
    popupState.close();
  };

  const handleMoveToOtherWarehouseClick = () => {
    setSelectWarehouseModalOpen(true);
    popupState.close();
  };

  const handleSelectWarehouse = warehouse => {
    setSelectedLocation(warehouse);
    setSelectWarehouseModalOpen(false);
  };

  const handleCloseFixedLocationModal = () => {
    setSelectedLocation(null);
  };

  const handleSubmitFixedLocation = ([location], mobileLocation, selectedLocation) => {
    const locations = [
      {
        ...location,
        ...(selectedLocation.mobile_warehouse_location && {
          mobile_warehouse_location: selectedLocation.mobile_warehouse_location,
        }),
      },
    ];
    onMoveToOtherWarehouse(locations, mobileLocation);
    setSelectedLocation(null);
  };

  const handleMoveOnlyThisItem = () => {
    onMoveOnlyThisItem();
    popupState.close();
  };

  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center">
      <Button
        variant="contained"
        color="primary"
        onClick={onOpenInventoryModal}
        sx={styles.selectButton}
      >
        {hasMobileLocation ? "Move Entire Mobile Location" : "Select New Location(s)"}
      </Button>
      <Box variant="contained" aria-label="split button">
        <Button
          variant="contained"
          color="primary"
          {...bindTrigger(popupState)}
          sx={styles.dropdownButton}
        >
          <KeyboardArrowDownIcon sx={styles.arrowIcon(popupState.isOpen)} />
        </Button>
        <Menu {...bindMenu(popupState)}>
          {hasMobileLocation && (
            <>
              <MenuItem onClick={handleConsolidateClick}>Consolidate Mobile Location</MenuItem>
              <MenuItem onClick={handleMoveOnlyThisItem}>Move Just This Item</MenuItem>
            </>
          )}
          <MenuItem onClick={handleMoveToOtherWarehouseClick}>Move to Other Warehouse</MenuItem>
        </Menu>
      </Box>
      <SelectWarehouseModal
        open={selectWarehouseModalOpen}
        onClose={() => setSelectWarehouseModalOpen(false)}
        onSelect={handleSelectWarehouse}
      />
      {selectedLocation && (
        <SelectNewLocationWithin
          location={selectedLocation}
          onClose={handleCloseFixedLocationModal}
          onSubmit={handleSubmitFixedLocation}
        />
      )}
    </Box>
  );
}
